let poly = require("preact-cli/lib/lib/webpack/polyfills");


import { h } from "preact";
import habitat from "preact-habitat";

import Services from "./components/services";
habitat(Services).render({
  selector: '[data-widget-host="habitat"]',
  clean: true,
});

import Map from "./components/map";
habitat(Map).render({
  selector: '[data-widget-host="map"]',
  clean: true,
});

import ShipsInPort from "./components/ships-in-port";
habitat(ShipsInPort).render({
  selector: '[data-widget-host="ships"]',
  clean: true,
});

import CruiseShips from "./components/cruises";
habitat(CruiseShips).render({
  selector: '[data-widget-host="cruise"]',
  clean: true,
});